import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { PostsApi } from "apis/PostsApi";
import {
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Button,
  Dialog,
  TextField,
  FormControlLabel,
  AppBar,
  Toolbar as MuiToolbar,
  IconButton,
  Typography,
  Slide,
  DialogActions,
  Radio,
  RadioGroup,
  FormLabel,
  DialogContent,
  DialogTitle,
  Tooltip,
  useMediaQuery,
  createSvgIcon,
} from "@mui/material";
import ReactPlayer from "react-player";
import CloseIcon from "@mui/icons-material/Close";
import MatAutoComplete from "components/MatAutoComplete/MatAutoComplete";
import { useNavigate } from "react-router";
import { BrandsApi } from "apis/BrandsApi";
import { GroupsApi } from "apis/GroupsApi";
import Grid from "@mui/material/Unstable_Grid2";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import {
  EditButton,
  FormCard,
  TableCard,
  Toolbar,
  ActionButton,
  DataTable,
  DataRow,
  Cell,
  StatusBadge,
  PageTitle,
  filterInputSx,
  filterSelectSx,
  filterFormControlSx,
} from "utils/ui";
import { formatDate } from "utils";
import { formatDateTimeComponent } from "utils";
import { MuiColorInput } from "mui-color-input";
import { useImageSize } from "react-image-size";
import { useDispatch, useSelector } from "react-redux";
import CircularIndeterminateModal from "../../utils/Loading";
import { setLoadingPanel } from "../../redux/features/loading";
const colorToHex = (color) => {
  if (!color) return "000000";
  if (color.startsWith("#")) return color.replace("#", "");
  if (color.startsWith("rgb")) {
    const rgbMatch = color.match(/\d+/g);
    if (rgbMatch && rgbMatch.length >= 3) {
      const r = parseInt(rgbMatch[0]).toString(16).padStart(2, "0");
      const g = parseInt(rgbMatch[1]).toString(16).padStart(2, "0");
      const b = parseInt(rgbMatch[2]).toString(16).padStart(2, "0");
      return `${r}${g}${b}`.toUpperCase();
    }
  }
  return color;
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Share() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);
  const [posts, setPosts] = useState();
  const [open, setOpen] = React.useState(false);
  
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const day = date.getDate();
  const periodFrom = `${year}-${month > 9 ? month : "0" + month}-01`;
  const lastDay = new Date(year, month, 0).getDate();
  const periodTo = `${year}-${month > 9 ? month : "0" + month}-${lastDay}`;
  const dateForAdd = new Date(year, month - 1, day);
  const periodFromForAdd = `${dateForAdd.getFullYear()}-${(
    dateForAdd.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${dateForAdd.getDate().toString().padStart(2, "0")}`;

  dateForAdd.setDate(dateForAdd.getDate() + 7);
  const periodToForAdd = `${dateForAdd.getFullYear()}-${(
    dateForAdd.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${dateForAdd.getDate().toString().padStart(2, "0")}`;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();

  const [brands, setBrands] = useState([]);
  const [selectedBrandInAddBrand, setSelectedBrandInAddBrand] = useState({});

  const [postAddPayload, setPostAddPayload] = useState({
    id: "",
    brand: null,
    url: "",
    periodFrom: periodFrom,
    periodTo: periodTo,
    name: {
      size: 42,
      padding: 20,
      font: "PaytoneOne-Regular.ttf",
      positionX: 0,
      positionY: 0,
      bgColor: "FFFFFF",
      textColor: "000000",
    },
    mobile: {
      size: 42,
      padding: 20,
      font: "PaytoneOne-Regular.ttf",
      positionX: 0,
      positionY: 500,
      bgColor: "FFFFFF",
      textColor: "000000",
    },
    type: "IMAGE",
    groups: [],
    isActive: true,
    isDeleted: false,
  });

  const [convertedURL, setConvertedURL] = useState("");

  const [brandFilter, setBrandFilter] = useState({});

  const handlePageChange = (event, page) => {
    setCurrentPage(page);

    getPosts(page - 1);
    return currentPage;
  };
  const [groupOptions, setGroupOptions] = useState([]);
  const getGroupData = (searchTerm) => {
    GroupsApi.GetGroupsListBySearch({
      page: 0,
      size: 10,
      keyword: searchTerm,
    }).then((res) => {
      const filter = res.data.data.filter((ele) => ele.isActive);
      const updatedOptions = filter.map((p) => {
        return {
          name: p.name,
          id: p.id,
        };
      });
      setGroupOptions(updatedOptions);
    });
  };
  const getSelectedGroups = (data) => {
    setPostAddPayload({
      ...postAddPayload,
      groups: data,
    });
  };

  const [totalElements, setTotalElements] = useState("");

  const getPosts = (page) => {
    dispatch(setLoadingPanel(true));
    PostsApi.GetSharePostsListByFilter({
      page: page,
      name: "Your Shop Name",
      mobile: "Your Number",
      size: 50,
      periodFrom: periodFrom,
      periodTo: periodTo,
      brandId: brandFilter?.id,
    })
      .then((res) => {
        setPosts(res.data.data);
        setTotalPages(res.data.pages);
        setTotalElements(res.data.totalElements);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };
  const handleResetFilter = () => {
    setBrandFilter("");
    getPosts(0);
    setCurrentPage(1);
  };
  const onBrandSelectInAddBrand = (event) => {
    const brand = event.target.value;
    if (event.target.value === null) {
      setPostAddPayload({
        ...postAddPayload,
        brand: null,
      });
      setSelectedBrandInAddBrand(null);
    } else {
      setSelectedBrandInAddBrand(brand);
      setPostAddPayload({
        ...postAddPayload,
        brand: {
          id: brand.id,
          name: brand.name,
          image: brand.image,
        },
      });
    }
  };

  const save = () => {
    if (!postAddPayload?.brand?.id) {
      toast("Add Brand", {
        type: "error",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          maxWidth: "90vw",
          width: "auto",
          margin: "5px  auto",
          padding: "5px 5px",
          fontSize: "14px",
        },
        closeButton: (
          <div className="flex justify-end">
            <button className="text-gray-500 hover:text-gray-800 focus:outline">
              <CloseIcon className="w-7 h-7" />
            </button>
          </div>
        ),
      });
      return;
    }
    if (!postAddPayload.groups.length) {
      toast("Add Group", {
        type: "error",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          maxWidth: "90vw",
          width: "auto",
          margin: "5px  auto",
          padding: "5px 5px",
          fontSize: "14px",
        },
        closeButton: (
          <div className="flex justify-end">
            <button className="text-gray-500 hover:text-gray-800 focus:outline">
              <CloseIcon className="w-7 h-7" />
            </button>
          </div>
        ),
      });
      return;
    }
    PostsApi.AddSharePost(postAddPayload)
      .then((res) => {
        toast("Post Share Added", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
        setOpen(false);
        getPosts(0);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const edit = (payload) => {
    PostsApi.UpdateSharePosts(payload).then((res) => {
      toast("Post Updated", {
        type: "success",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          maxWidth: "90vw",
          width: "auto",
          margin: "5px  auto",
          padding: "5px 5px",
          fontSize: "14px",
        },
        closeButton: (
          <div className="flex justify-end">
            <button className="text-gray-500 hover:text-gray-800 focus:outline">
              <CloseIcon className="w-7 h-7" />
            </button>
          </div>
        ),
      });
      getPosts(currentPage - 1);
      setOpen(false);
    });
  };
  const handleClose = () => {
    setOpen(false);
  };

  const openAddUpdateBrands = () => {
    setPostAddPayload({
      id: "",
      brand: null,
      url: "",
      periodFrom: periodFromForAdd,
      periodTo: periodToForAdd,
      name: {
        size: 42,
        padding: 20,
        font: "PaytoneOne-Regular.ttf",
        positionX: 0,
        positionY: 0,
        bgColor: "FFFFFF",
        textColor: "000000",
      },
      mobile: {
        size: 42,
        padding: 20,
        font: "PaytoneOne-Regular.ttf",
        positionX: 0,
        positionY: 500,
        bgColor: "FFFFFF",
        textColor: "000000",
      },
      type: "IMAGE",
      groups: [],
      isActive: true,
      isDeleted: false,
    });
    setConvertedURL("");
    setOpen(true);
  };
  const getBrands = () => {
    dispatch(setLoadingPanel(true));
    BrandsApi.GetBrandsListByFilter({
      page: 0,
      size: 99,
    })
      .then((res) => {
        setBrands(res.data.data.filter((d) => d.isActive));
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  useEffect(() => {
    getPosts(currentPage - 1);
  }, [currentPage, brandFilter]);

  useEffect(() => {
    getBrands();
  }, []);
  const [dimensions] = useImageSize(
    postAddPayload.url.includes("?")
      ? postAddPayload.url.split("?")[0]
      : postAddPayload.url
  );

  useEffect(() => {
    if (dimensions) {
      setPostAddPayload((prev) => ({
        ...prev,
        name: {
          ...prev.name,
          positionX: prev.name?.positionX || dimensions.width,
          positionY: prev.name?.positionY || dimensions.height,
        },
        mobile: {
          ...prev.mobile,
          positionX: prev.mobile?.positionX || dimensions.width,
          positionY: prev.mobile?.positionY || dimensions.height,
        },
      }));
    }
  }, [dimensions]);


  useEffect(() => {
    if (postAddPayload.url) {
      let urlArray = postAddPayload.url.includes("?") ? postAddPayload.url.split("?") : [postAddPayload.url];
      const converted = `${urlArray[0]}?tr=l-text,pa-${postAddPayload.name.padding},ff-${postAddPayload.name.font},i-Your Shop Name,ly-${postAddPayload.name.positionY},lx-${postAddPayload.name.positionX},bg-${postAddPayload.name.bgColor},co-${postAddPayload.name.textColor},tg-b,fs-${postAddPayload.name.size},l-end:l-text,i-Your Number,ly-${postAddPayload.mobile.positionY},co-${postAddPayload.mobile.textColor},lx-${postAddPayload.mobile.positionX},pa-${postAddPayload.mobile.padding},ff-${postAddPayload.mobile.font},bg-${postAddPayload.mobile.bgColor},fs-${postAddPayload.mobile.size},tg-b,l-end`;
      setConvertedURL(converted);
    }
  }, [postAddPayload.url, postAddPayload.name, postAddPayload.mobile]);

  const isMobile = useMediaQuery("(max-width:768px)");
  const PlusIcon = createSvgIcon(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>,
    "Plus"
  );


  return (
    <>
      <CircularIndeterminateModal open={isLoading && !brands.length} />
      <FormCard>
        <PageTitle title="Share Posts" subtitle={`Total Shares: ${totalElements}`} />
        <Toolbar>
          <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 3, width: "100%" }}>
            <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: 300 } }}>
              <FormControl fullWidth sx={filterFormControlSx}>
                <InputLabel>Brand</InputLabel>
                <Select
                  value={brandFilter || ""}
                  label="Brand"
                  onChange={(e) => setBrandFilter(e.target.value)}
                  sx={filterSelectSx}
                >
                  <MenuItem value="">--Select Brand--</MenuItem>
                  {brands.map((b, i) => (
                    <MenuItem key={i} value={b}>{b.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: { xs: "100%", sm: "auto" }, justifyContent: { xs: "space-between", sm: "flex-end" } }}>
              <ActionButton variant="secondary" onClick={handleResetFilter} fullWidth={{ xs: true, sm: false }}>
                Reset Filter
              </ActionButton>
              <ActionButton variant="primary" icon="fas fa-plus" onClick={openAddUpdateBrands} fullWidth={{ xs: true, sm: false }}>
                Add Share
              </ActionButton>
            </Box>
          </Box>
        </Toolbar>
      </FormCard>
      <TableCard>
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 3, p: 4, borderBottom: "1px solid", borderColor: "slate.100", justifyContent: { xs: "center", sm: "space-between" } }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            color="primary"
            size="small"
            onChange={handlePageChange}
            sx={{ "& .MuiPagination-ul": { justifyContent: "center" } }}
          />
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            Total: <span className="text-indigo-600 font-bold">{totalElements}</span> shares
          </Typography>
        </Box>
        <DataTable
          headers={[
            "",
            "Brand",
            "Preview",
            "Period",
            "Status",
            "Groups",
            "Created On",
            "Type",
            "Actions"
          ]}
        >
          {posts &&
            posts.map((p, i) => (
              <PostRow
                key={p.id}
                currentPage={currentPage}
                p={p}
                i={i}
                setPostAddPayload={setPostAddPayload}
                setOpen={setOpen}
                edit={edit}
              />
            ))}
        </DataTable>
      </TableCard>

      <Dialog
        maxWidth="lg"
        fullWidth
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            {postAddPayload.id ? "Edit Post Share" : "Add New Post Share"}
          </Typography>
          <IconButton onClick={handleClose} size="small" sx={{ color: 'slate.500' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: { xs: 2, sm: 4, lg: 6 } }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3, position: { md: "sticky" }, top: 0 }}>
                <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>
                  Live Preview
                </Typography>
                <Box sx={{ position: "relative", aspectRatio: "1/1", borderRadius: 3, overflow: "hidden", bgcolor: "slate.100", border: "4px solid white", boxShadow: 4 }}>
                  {postAddPayload.type === "VIDEO" ? (
                    <ReactPlayer
                      playing={true}
                      loop={true}
                      muted={true}
                      width="100%"
                      height="100%"
                      url={convertedURL}
                      controls={false}
                    />
                  ) : (
                    <img
                      loading="lazy"
                      className="w-full h-full object-contain"
                      src={convertedURL}
                      alt="preview"
                    />
                  )}
                  {dimensions && (
                    <Box sx={{ position: "absolute", bottom: 8, left: 8, bgcolor: "black/50", backdropFilter: "blur(8px)", color: "white", fontSize: "10px", px: 1, py: 0.5, borderRadius: 1 }}>
                      {dimensions.width} x {dimensions.height} px
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={7}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <Box component="section">
                  <Typography variant="subtitle2" sx={{ mb: 3, fontWeight: 700, color: 'slate.700', textTransform: "uppercase", letterSpacing: "0.05em" }}>Basic Configuration</Typography>
                  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 3 }}>
                    <TextField
                      onChange={(e) => setPostAddPayload({ ...postAddPayload, url: e.target.value })}
                      value={postAddPayload.url}
                      fullWidth
                      label="Asset URL"
                      placeholder="Enter image or video URL"
                    />
                    <FormControl fullWidth>
                      <InputLabel>Asset Type</InputLabel>
                      <Select
                        value={postAddPayload.type}
                        label="Asset Type"
                        onChange={(e) => setPostAddPayload({ ...postAddPayload, type: e.target.value })}
                      >
                        <MenuItem value="IMAGE">Image</MenuItem>
                        <MenuItem value="VIDEO">Video</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>Target Brand</InputLabel>
                      <Select
                        value={selectedBrandInAddBrand}
                        label="Target Brand"
                        onChange={onBrandSelectInAddBrand}
                      >
                        <MenuItem value={null}>--Select Brand--</MenuItem>
                        {brands.map((b, i) => <MenuItem key={i} value={b}>{b.name}</MenuItem>)}
                      </Select>
                    </FormControl>
                    <MatAutoComplete
                      label="Target Groups"
                      getData={getGroupData}
                      options={groupOptions}
                      setOptions={setGroupOptions}
                      setValue={getSelectedGroups}
                      isMultiple={true}
                      initialValue={postAddPayload.groups}
                    />
                  </Box>
                </Box>

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 4, p: 3, borderRadius: 3, bgcolor: "slate.50", border: "1px solid", borderColor: "slate.100" }}>
                  <Box>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 700, color: 'primary.main', textTransform: "uppercase", fontSize: "0.7rem", letterSpacing: "0.05em" }}>Shop Name Styling</Typography>
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                      <TextField size="small" type="number" label="Font Size" value={postAddPayload.name.size} onChange={(e) => setPostAddPayload(p => ({ ...p, name: { ...p.name, size: e.target.value } }))} />
                      <TextField size="small" type="number" label="Padding" value={postAddPayload.name.padding} onChange={(e) => setPostAddPayload(p => ({ ...p, name: { ...p.name, padding: e.target.value } }))} />
                      <TextField size="small" type="number" label="X Pos" value={postAddPayload.name.positionX} onChange={(e) => setPostAddPayload(p => ({ ...p, name: { ...p.name, positionX: e.target.value } }))} />
                      <TextField size="small" type="number" label="Y Pos" value={postAddPayload.name.positionY} onChange={(e) => setPostAddPayload(p => ({ ...p, name: { ...p.name, positionY: e.target.value } }))} />
                      <FormControl fullWidth size="small" sx={{ gridColumn: 'span 2' }}>
                        <InputLabel>Font Family</InputLabel>
                        <Select value={postAddPayload.name.font} label="Font Family" onChange={(e) => setPostAddPayload(p => ({ ...p, name: { ...p.name, font: e.target.value } }))}>
                          <MenuItem value="PaytoneOne-Regular.ttf">Paytone One</MenuItem>
                          <MenuItem value="Gabarito-ExtraBold.ttf">Gabarito</MenuItem>
                          <MenuItem value="Comfortaa-Bold.ttf">Comfortaa</MenuItem>
                        </Select>
                      </FormControl>
                      <MuiColorInput size="small" format="hex" label="Text" value={`#${postAddPayload.name.textColor}`} onChange={(c) => setPostAddPayload(p => ({ ...p, name: { ...p.name, textColor: colorToHex(c) } }))} />
                      <MuiColorInput size="small" format="hex" label="BG" value={`#${postAddPayload.name.bgColor}`} onChange={(c) => setPostAddPayload(p => ({ ...p, name: { ...p.name, bgColor: colorToHex(c) } }))} />
                    </Box>
                  </Box>

                  <Box>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 700, color: 'secondary.main', textTransform: "uppercase", fontSize: "0.7rem", letterSpacing: "0.05em" }}>Mobile Styling</Typography>
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                      <TextField size="small" type="number" label="Font Size" value={postAddPayload.mobile.size} onChange={(e) => setPostAddPayload(p => ({ ...p, mobile: { ...p.mobile, size: e.target.value } }))} />
                      <TextField size="small" type="number" label="Padding" value={postAddPayload.mobile.padding} onChange={(e) => setPostAddPayload(p => ({ ...p, mobile: { ...p.mobile, padding: e.target.value } }))} />
                      <TextField size="small" type="number" label="X Pos" value={postAddPayload.mobile.positionX} onChange={(e) => setPostAddPayload(p => ({ ...p, mobile: { ...p.mobile, positionX: e.target.value } }))} />
                      <TextField size="small" type="number" label="Y Pos" value={postAddPayload.mobile.positionY} onChange={(e) => setPostAddPayload(p => ({ ...p, mobile: { ...p.mobile, positionY: e.target.value } }))} />
                      <FormControl fullWidth size="small" sx={{ gridColumn: 'span 2' }}>
                        <InputLabel>Font Family</InputLabel>
                        <Select value={postAddPayload.mobile.font} label="Font Family" onChange={(e) => setPostAddPayload(p => ({ ...p, mobile: { ...p.mobile, font: e.target.value } }))}>
                          <MenuItem value="PaytoneOne-Regular.ttf">Paytone One</MenuItem>
                          <MenuItem value="Gabarito-ExtraBold.ttf">Gabarito</MenuItem>
                          <MenuItem value="Comfortaa-Bold.ttf">Comfortaa</MenuItem>
                        </Select>
                      </FormControl>
                      <MuiColorInput size="small" format="hex" label="Text" value={`#${postAddPayload.mobile.textColor}`} onChange={(c) => setPostAddPayload(p => ({ ...p, mobile: { ...p.mobile, textColor: colorToHex(c) } }))} />
                      <MuiColorInput size="small" format="hex" label="BG" value={`#${postAddPayload.mobile.bgColor}`} onChange={(c) => setPostAddPayload(p => ({ ...p, mobile: { ...p.mobile, bgColor: colorToHex(c) } }))} />
                    </Box>
                  </Box>
                </Box>

                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 3, fontWeight: 700, color: 'slate.700', textTransform: "uppercase", letterSpacing: "0.05em" }}>Schedule & Visibility</Typography>
                  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr 1fr" }, gap: 3 }}>
                    <TextField type="date" label="Valid From" value={postAddPayload.periodFrom} fullWidth InputLabelProps={{ shrink: true }} onChange={(e) => setPostAddPayload({ ...postAddPayload, periodFrom: e.target.value })} />
                    <TextField type="date" label="Valid To" value={postAddPayload.periodTo} fullWidth InputLabelProps={{ shrink: true }} onChange={(e) => setPostAddPayload({ ...postAddPayload, periodTo: e.target.value })} />
                    <FormControl size="small">
                      <FormLabel sx={{ fontSize: '0.75rem', fontWeight: 600 }}>Active</FormLabel>
                      <RadioGroup row value={postAddPayload.isActive} onChange={(e) => setPostAddPayload({ ...postAddPayload, isActive: e.target.value === 'true' })}>
                        <FormControlLabel value={true} control={<Radio size="small" />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio size="small" />} label="No" />
                      </RadioGroup>
                    </FormControl>
                    <FormControl size="small">
                      <FormLabel sx={{ fontSize: '0.75rem', fontWeight: 600 }}>Deleted</FormLabel>
                      <RadioGroup row value={postAddPayload.isDeleted} onChange={(e) => setPostAddPayload({ ...postAddPayload, isDeleted: e.target.value === 'true' })}>
                        <FormControlLabel value={true} control={<Radio size="small" />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio size="small" />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: 'slate.50/50', borderTop: '1px solid', borderColor: 'slate.100' }}>
          <ActionButton variant="secondary" onClick={handleClose}>Cancel</ActionButton>
          <ActionButton variant="primary" onClick={() => postAddPayload.id ? edit(postAddPayload) : save()}>
            {postAddPayload.id ? "Save Changes" : "Create Share Post"}
          </ActionButton>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </>
  );
}

export default Share;

const PostRow = ({ p, i, currentPage, setPostAddPayload, setOpen, edit }) => {
  const [isGroupOpen, setIsGroupOpen] = useState(false);

  return (
    <DataRow>
      <Cell variant="index" value={50 * (currentPage - 1) + i + 1} />
      <Cell value={p.brand?.name} />
      
      <Cell
        value={
          p.url && p.type === "IMAGE" && (
            <div className="relative group overflow-hidden rounded-md border border-slate-100 w-40 h-40">
              <img
                loading="lazy"
                className="w-full h-full object-contain bg-slate-50 transition-transform duration-300 group-hover:scale-110"
                src={p.url.startsWith("https://") ? p.url : "https://" + p.url}
                alt="post"
              />
            </div>
          )
        }
      />

      <Cell
        primary={formatDate(p.periodFrom)}
        secondary={formatDate(p.periodTo)}
      />

      <Cell
        value={
          <div className="flex flex-col gap-1">
            <StatusBadge
              status={p.isActive ? "Active" : "Inactive"}
              variant={p.isActive ? "success" : "neutral"}
              onDoubleClick={() => edit({ ...p, isActive: !p.isActive })}
            />
            {p.isDeleted && <StatusBadge status="Deleted" variant="error" />}
          </div>
        }
      />

      <Cell
        value={
          <ActionButton variant="secondary" size="small" onClick={() => setIsGroupOpen(true)}>
            View Groups ({p.groups?.length || 0})
          </ActionButton>
        }
      />

      <Cell value={formatDateTimeComponent(p.createdOn)} />
      <Cell value={<StatusBadge status={p.type} variant="info" />} />

      <Cell
        value={
          <EditButton onClick={() => {
            setPostAddPayload(p);
            setOpen(true);
          }} />
        }
      />

      <Dialog
        maxWidth="xs"
        fullWidth
        open={isGroupOpen}
        onClose={() => setIsGroupOpen(false)}
      >
        <DialogTitle>Assigned Groups</DialogTitle>
        <DialogContent sx={{ minWidth: 300 }}>
          <div className="flex flex-wrap gap-2 py-2">
            {p.groups?.map((g, idx) => (
              <StatusBadge key={idx} status={g.name} variant="info" />
            ))}
            {(!p.groups || p.groups.length === 0) && (
              <span className="text-slate-400 italic text-sm">No groups assigned</span>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <ActionButton variant="secondary" onClick={() => setIsGroupOpen(false)}>Close</ActionButton>
        </DialogActions>
      </Dialog>
    </DataRow>
  );
};
